module.exports = __webpack_public_path__ + "static/media/gifts.69784407.svg";